
<div #canvasParent class="logblock">
    <div class="words">
        <div #word1Label [ngClass]="{'word1selected': isSelected(0), 'word': !forForecast, 'wordForecast': forForecast }" (click)="setSelected(0);">
            {{word1}}
        </div>
        <div #word2Label [ngClass]="{'word2selected': isSelected(2), 'word': !forForecast, 'wordForecast': forForecast}" (click)="setSelected(2);">
            {{word2}}
        </div>
        <div #word3Label [ngClass]="{'word3selected': isSelected(4), 'word': !forForecast, 'wordForecast': forForecast}" (click)="setSelected(4);">
            {{word3}}
        </div>
    </div>
    <canvas #loggingCanvas></canvas>
</div>

<div>
    <p *ngIf="getYesterdayValue() && undefined != getYesterdayValue()" class="summary2">{{getYesterdayValue()}} {{getYesterdayText()}}</p>
    <p *ngIf="getYesterdayValue() &&  undefined === getYesterdayValue()" class="summary2"> {{data.getName()}} not logged {{getYesterdayText()}}.</p>
</div>
 
